import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

export const Wrench = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m16 10.667 3.525-3.526c.302.67.475 1.41.475 2.192a5.334 5.334 0 0 1-5.333 5.334c-.477 0-.937-.069-1.377-.186L8.552 19.22A2.66 2.66 0 0 1 6.667 20a2.667 2.667 0 0 1-1.885-4.553l4.737-4.738a5.32 5.32 0 0 1-.186-1.376A5.334 5.334 0 0 1 14.667 4c.782 0 1.522.173 2.192.475L13.333 8v2.667H16ZM6 17.333a.667.667 0 1 0 1.334 0 .667.667 0 0 0-1.334 0Z"
        fill={props.color || theme.palette.grey600}
      />
    </svg>
  );
};
